import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';
import SEO from '../components/SEO';

const Ecommerce = () => {
    useEffect(() => {
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
        }
        if (window.WOW) {
            new window.WOW().init();
        }
    }, []);

    const schema = {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "eCommerce Development",
        "provider": {
            "@type": "LocalBusiness",
            "name": "WebBears"
        },
        "description": "Professional eCommerce web development services building secure, scalable, and high-converting online stores using Shopify, WooCommerce, and Custom Tech Stacks."
    };

    return (
        <>
            <SEO 
                title="Expert eCommerce Website Developer | WebBears"
                description="Looking for an eCommerce website developer? WebBears engineers high-converting, scalable online stores using Shopify, WooCommerce, and Custom React stacks."
                keywords="ecommerce developer in mumbai, ecommerce website developer, shopify expert, boba custom ecommerce, online store developer"
                url="https://webbears.com/ecommerce-development"
                schemaMarkup={schema}
            />
            <WhatsAppFloat />
            <Navbar />

            <div className="container-fluid page-header mb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container mt-5 pt-5 text-center">
                    <h1 className="display-4 animated slideInDown">eCommerce Development</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb justify-content-center mb-0">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item"><a href="/service">Services</a></li>
                            <li className="breadcrumb-item active" aria-current="page">eCommerce Developer</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <img className="img-fluid rounded shadow" src="img/images/e-commerce.png" alt="ecommerce developer creating an online store dashboard" />
                        </div>
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
                            <p className="d-inline-block border rounded text-primary fw-semi-bold py-1 px-3">Scaling Online Retail</p>
                            <h2 className="display-5 mb-4">Your Dedicated eCommerce Website Developer</h2>
                            <p className="mb-4">
                                Retail is moving online faster than ever before. If you run a retail business or wholesale logistics center, a traditional website isn't enough. You need an automated, high-converting eCommerce machine.
                            </p>
                            <p className="mb-4">
                                As a premier <strong>eCommerce developer perfectly situated to serve Mumbai and surrounding regions</strong>, WebBears specializes in migrating brick-and-mortar stores into the digital realm. Whether you need a standard WooCommerce platform, a robust enterprise Shopify setup, or a fully custom <a href="/web-development">React-based Web Application</a>, we have the technical prowess to deliver.
                            </p>
                            <a href="/contact" className="btn btn-primary py-3 px-5 mb-4">Start Selling Online</a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-xxl py-5 bg-light">
                <div className="container">
                    <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '800px' }}>
                        <h2 className="display-6 mb-5">Features Engineered for Maximum Sales</h2>
                    </div>
                    <div className="row g-4">
                        <div className="col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="bg-white p-4 rounded border h-100 text-center shadow-sm">
                                <i className="fa fa-3x fa-credit-card text-primary mb-3"></i>
                                <h3 className="h5 mb-3">Payment Gateway Integration</h3>
                                <p>We integrate secure, smooth, and multi-currency payment providers including Razorpay, Stripe, and PayPal to eliminate checkout friction.</p>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="bg-white p-4 rounded border h-100 text-center shadow-sm">
                                <i className="fa fa-3x fa-mobile-alt text-primary mb-3"></i>
                                <h3 className="h5 mb-3">Mobile-First Commerce</h3>
                                <p>Knowing that mobile commerce commands 80% of current retail traffic, our UI designs prioritize sticky Add-to-Cart buttons and mobile-friendly catalogs.</p>
                            </div>
                        </div>
                        <div className="col-md-4 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="bg-white p-4 rounded border h-100 text-center shadow-sm">
                                <i className="fa fa-3x fa-chart-line text-primary mb-3"></i>
                                <h3 className="h5 mb-3">Marketing Automations</h3>
                                <p>Built-in cart abandonment tracking. Once your store is live, our <a href="/smedia">Digital Marketing agency</a> experts can pump high-intent traffic to your products.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Ecommerce;
